import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ToastrService } from 'ngx-toastr';
import { downloadFiles } from '../../utils';

@Component({
  selector: 'lib-line-items',
  templateUrl: './line-items.component.html',
  styleUrls: ['./line-items.component.scss'],
})
export class LineItemsComponent implements OnInit {
  lineItems: any;
  isAttachmentTrue: any;
  @Input() custRfqId!: number;
  @Input() baseUrl: any;
  @Input() lineItemsSup: any;
  @Input() isSupplier: boolean = false;
  @Input() isSubRFQ: boolean = false;
  tooltipState: { [key: number]: boolean } = {};
  constructor(
    private commonService: CommonService,
    private toastr: ToastrService,
  ) {}
  ngOnInit() {
    if (this.isSupplier || this.isSubRFQ) {
      this.lineItems = this.lineItemsSup;
      this.isAttachmentTrue = this.checkCol4Data();
    } else {
      this.getLineItems();
    }
  }

  getLineItems() {
    let apiUrl = `${this.baseUrl}rfq/cart/getLineCart/${this.custRfqId}`;
    this.commonService.getData(apiUrl).subscribe((data: any) => {
      this.lineItems = data.response;
      this.isAttachmentTrue = this.checkCol4Data();
    });
  }

  checkCol4Data(): boolean {
    return this.lineItems.some((row: any) => row.attachment !== null);
  }

  downloadBrochureFile(id: number, fileName: string): void {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, fileName);
  }

  getTruncatedString(value: string, limit: number = 8): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) : value;
  }
  showTooltip(id: number, isVisible: boolean) {
    this.tooltipState[id] = isVisible;
  }
}
